var exports = {
  "wx": "InboxMessageHeader.module__header___MlZoQ2",
  "LD": "InboxMessageHeader.module__headerLeft___MlZoQ2",
  "$s": "InboxMessageHeader.module__headerActions___MlZoQ2",
  "FW": "InboxMessageHeader.module__headerIconButton___MlZoQ2",
  "nr": "InboxMessageHeader.module__headerIcon___MlZoQ2",
};

module.exports = exports;
